export async function setLocalStorage(keyName: string, keyValue: string | Record<string, unknown>) {
  // Handle both string and object values - only stringify once
  const valueToStore = typeof keyValue === 'string' ? keyValue : JSON.stringify(keyValue);
  return await window.localStorage.setItem(keyName, valueToStore);
}
export function getLocalStorage(keyName: string) {
  try {
    const result = keyName ? window.localStorage.getItem(keyName) : '';
    return result ? JSON.parse(result) : '';
  } catch (e) {
    return '';
  }
}
export function deleteLocalStorage(keyName: string) {
  window.localStorage.removeItem(keyName);
  return true;
}

/**
 * Check if the stored token is expired
 * @returns true if token is expired or invalid, false if still valid
 */
export function isTokenExpired(): boolean {
  try {
    const tokens = getLocalStorage('tokens');
    if (!tokens) return true;

    // Parse if string (backward compatibility)
    const parsed = typeof tokens === 'string' ? JSON.parse(tokens) : tokens;

    // If no expiry info, assume valid (let API reject if invalid)
    if (!parsed?.expires_in) return false;

    // Calculate expiry time
    // created_at is Unix timestamp in seconds, expires_in is seconds
    const createdAt = parsed.created_at ? parsed.created_at * 1000 : Date.now();
    const expiresAt = createdAt + parsed.expires_in * 1000;

    // Add 60 second buffer to avoid edge cases
    return Date.now() > expiresAt - 60000;
  } catch (e) {
    console.warn('Error checking token expiry:', e);
    return true; // Treat errors as expired
  }
}
